module.exports = __webpack_public_path__ + "img/home_quienes-somos.1ab5affe.png";